import { Badge, type DefaultMantineColor } from '@any-ui-react/core';
import { ExportImportStatus } from '@/common/graphql';

const EXPORT_IMPORT_STATUS_LABELS: Record<ExportImportStatus, string> = {
  [ExportImportStatus.Accepted]: 'Accepted',
  [ExportImportStatus.InProgress]: 'In Progress',
  [ExportImportStatus.Done]: 'Done',
  [ExportImportStatus.Failed]: 'Failed',
};

// Colors must exist in the app theme's `other.statusColor` map (used by the custom Badge "status"
// variant) - not the full Mantine palette. Unsupported names (e.g. "orange") silently fall back to
// the theme's primaryColor (blue), which is why this must be checked against that map, not guessed.
const EXPORT_IMPORT_STATUS_COLORS: Record<ExportImportStatus, DefaultMantineColor> = {
  [ExportImportStatus.Accepted]: 'gray',
  [ExportImportStatus.InProgress]: 'yellow',
  [ExportImportStatus.Done]: 'blue',
  [ExportImportStatus.Failed]: 'red',
};

export const CellValueStatus = ({ status }: { status: ExportImportStatus }) => (
  <Badge color={EXPORT_IMPORT_STATUS_COLORS[status]}>{EXPORT_IMPORT_STATUS_LABELS[status]}</Badge>
);
